import Image from 'next/image';
import styles from './trusted-by.module.scss';
import { wallexState } from '../../wallex.state';

const TrustedBy = () => {
  const { trustedBy } = wallexState;
  return (
    <div className={styles.container}>
      <section className={styles.section}>
        <h3 className={styles.section__title}>{trustedBy.title}</h3>
        <div className={styles.section__block}>
          {trustedBy.icons.map((icon, idx) => (
            <Image
              key={idx}
              src={icon.url}
              alt={icon.alt}
              height={icon.height}
              width={icon.width}
              layout={'fixed'}
            />
          ))}
        </div>
      </section>
    </div>
  )
}

export default TrustedBy;
